import React from 'react';
import { FlatList, Text, View, StyleSheet, Image, TouchableOpacity } from 'react-native';
import { isBlank } from '../../utils/BooleanUtility';
import RoutineCommonActivities from './RoutineCommonActivities';

const RoutineRailList = (props) => {
  const { itemData = [], myRewardPoints = '', isRoutineActive } = props;
  const renderItem = ({ item }) => {
    if (isBlank(item)) return null;
    const { activity = {}, activityType = '' } = item;
    return <RoutineCommonActivities itemData={activity} activityType={activityType} myRewardPoints={myRewardPoints} isRoutineActive={isRoutineActive}/>;
  };

  return (
    <FlatList
      data={itemData}
      horizontal
      showsHorizontalScrollIndicator={false}
      keyExtractor={(item, index) => item.id || index.toString()}
      renderItem={renderItem}
      contentContainerStyle={styles.listContainer}
    />
  );
};

const styles = StyleSheet.create({
  listContainer: {
    paddingHorizontal: 16,
  },
  itemContainer: {
    marginRight: 16,
    alignItems: 'center',
  },
  image: {
    width: 80,
    height: 80,
    borderRadius: 8,
    marginBottom: 8,
  },
  title: {
    fontSize: 14,
    color: '#333',
    textAlign: 'center',
  },
});

export default RoutineRailList;
